import React from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { FaHome, FaUsers, FaLayerGroup, FaPrint } from 'react-icons/fa';

const Navigation = () => {
  return (
    <Navbar bg="primary" variant="dark" expand="lg">
      <Container>
        <Navbar.Brand href="/">
          <FaPrint className="me-2" />
          Gestion Cartes de Pointage
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <LinkContainer to="/">
              <Nav.Link>
                <FaHome className="me-1" />
                Accueil
              </Nav.Link>
            </LinkContainer>
            <LinkContainer to="/agents">
              <Nav.Link>
                <FaUsers className="me-1" />
                Agents
              </Nav.Link>
            </LinkContainer>
            <LinkContainer to="/groupes">
              <Nav.Link>
                <FaLayerGroup className="me-1" />
                Groupes
              </Nav.Link>
            </LinkContainer>
            <LinkContainer to="/cartes-pointage">
              <Nav.Link>
                <FaPrint className="me-1" />
                Cartes de Pointage
              </Nav.Link>
            </LinkContainer>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Navigation; 